export function getRankLabel(rank: number): string {
    if (rank === 1) {
        return `${rank}er lugar`;
    } else if (rank === 2) {
        return `${rank}do lugar`;
    } else if (rank === 3) {
        return `${rank}er lugar`;
    } else if (rank >= 4 && rank <= 6) {
        return `${rank}to lugar`;
    } else if (rank === 7) {
        return `${rank}mo lugar`;
    } else if (rank === 8) {
        return `${rank}vo lugar`;
    } else if (rank === 9) {
        return `${rank}no lugar`;
    } else {
        return `${rank}° lugar`;
    }
}